import React from 'react'
import { isNull } from 'lodash'
import Select from 'UI/Select'

const MultiSelect = ({
  options,
  handleFieldValue,
  columnFieldName,
  fields
}) => {
  let value = []

  if (!isNull(fields[columnFieldName])) value = fields[columnFieldName]

  return (
    <Select
      options={options}
      styles={{ container: base => ({ ...base }) }}
      onChange={option => handleFieldValue(option)}
      value={value}
      menuPortalTarget={document.querySelector("body")}
      isMulti
    />
  )
}

export default MultiSelect
